import PropTypes from 'prop-types';

import { BackendState, BackendStateWithData } from '../../types';
import { OfferDetailsDTO } from '../../types/dto/OfferDetailsDTO';
import { OfferShortDTO } from '../../types/dto/OfferShortDTO';
import { VoucherDTO } from '../../types/dto/VoucherDTO';

//////////////////////////////////////////////////////////////////////////////////////////
// Misc shapes
//////////////////////////////////////////////////////////////////////////////////////////
export interface OfferErrorInfo {
    response: any;
    errorCode: string;
    errorMessage: string | null;
    exceptionType: string | null;
}

export class OfferError extends Error {
    public offerErrorInfo: OfferErrorInfo;

    constructor(offerErrorInfo: OfferErrorInfo, ...params: any[]) {
        // Pass remaining arguments (including vendor specific ones) to parent constructor
        super(...params);

        // Maintains proper stack trace for where our error was thrown (only available on V8)
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, OfferError);
        }

        if (offerErrorInfo.errorMessage !== null) {
            this.message = offerErrorInfo.errorMessage;
        }
        // Custom debugging information
        this.offerErrorInfo = offerErrorInfo;
    }
}

export interface AllOffers {
    readonly offers: OfferShortDTO[];
}

export interface GetOffer {
    readonly offer?: OfferDetailsDTO;
}

export interface GetVoucher {
    readonly voucher?: VoucherDTO;
}

export interface PrintVoucher {
    readonly voucher?: Blob;
}

export interface AllOffersState extends BackendStateWithData<OfferShortDTO[]> { }
export interface GetOfferState extends BackendStateWithData<OfferDetailsDTO> { }
export interface RequestVoucherState extends BackendState { }
export interface GetVoucherState extends BackendStateWithData<VoucherDTO> { }
export interface PrintVoucherState extends BackendStateWithData<Blob | undefined > {}

export interface OfferState {
    readonly allOffers: AllOffersState;
    readonly getOffer: GetOfferState;
    readonly requestVoucher: RequestVoucherState;
    readonly getVoucher: GetVoucherState;
    readonly printVoucher: PrintVoucherState;
}

//////////////////////////////////////////////////////////////////////////////////////////
// Action shapes
//////////////////////////////////////////////////////////////////////////////////////////

export const OfferActionPropTypes = PropTypes.shape({
    allOffersRequest: PropTypes.func.isRequired,
    allOffersSuccess: PropTypes.func.isRequired,
    allOffersFailure: PropTypes.func.isRequired,

    getOfferRequest: PropTypes.func.isRequired,
    getOfferSuccess: PropTypes.func.isRequired,
    getOfferFailure: PropTypes.func.isRequired,

    requestVoucherRequest: PropTypes.func.isRequired,
    requestVoucherSuccess: PropTypes.func.isRequired,
    requestVoucherFailure: PropTypes.func.isRequired,

    getVoucherRequest: PropTypes.func.isRequired,
    getVoucherSuccess: PropTypes.func.isRequired,
    getVoucherFailure: PropTypes.func.isRequired,

    printVoucherRequest: PropTypes.func.isRequired,
    printVoucherSuccess: PropTypes.func.isRequired,
    printVoucherFailure: PropTypes.func.isRequired,
});
